export function debounce<T extends (...args: never[]) => unknown>(
  func: T,
  delay: number | undefined,
) {
  const timeToDelay = delay || 500;
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: unknown, ...args: Parameters<T>) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, timeToDelay);
  };
}
